import * as Logger from './logger.js'
import { HSCard } from './card.js';
import styles from './editor.css';
import template from './editor.html';
import { createJSONEditor } from 'vanilla-jsoneditor';

export class HSEditor extends HSCard {
    config = {};

    constructor() {
        super();
    }

    onLoad() {
        this.showLoading();
        this.loadTemplate(template);
        this.loadStyles(styles);
        this.editor = createJSONEditor({ 
            target: this.shadowRoot.getElementById('jsoneditor'),
            props: { 
                mode: 'text',
                mainMenuBar: false,
                navigationBar: false,
                statusBar: false,
                askToFormat: false,
            } 
        });
    }

    onUnload() {
        super.onUnload();
        this.abort();
        this.editor.destroy();
    }

    init(config) {
        this.config = config;
    }

    setContent(json) {
        this.editor.set({ json });
        this.hideLoading();
    }

    isValid() {
        // validate() returns 'undefined' if there are no errors
        return this.editor.validate() === undefined;
    }

    getContent() {
        const content = this.editor.get();
        //Logger.debug("content: ", content);
        if (content.json) {
            return content.json;
        } else if (content.text) {
            return JSON.parse(content.text);
        } else {
            throw new Error("no content available from JSON editor");
        }
    }
}
customElements.define('hs-editor', HSEditor);

